module.exports = __webpack_public_path__ + "media/images/lineup__synching-dc375f50843bb42d20fb233e8f76f5d1.png";